var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","fill-height":"","justify-center":"","align-center":""}},[_c('div',{staticClass:"not-f8 font-weight-bold ml-5 c5--text"},[_vm._v("Our site is launching soon..")]),_c('div',{staticClass:"not-f font-weight-bol ml-5 sc5--tex"},[_vm._v("info@futuretoursmw.com")])])
}
var staticRenderFns = []

export { render, staticRenderFns }